import { getArea } from 'ol/sphere';
import GeometryType from 'ol/geom/GeometryType';
import Geometry from 'ol/geom/Geometry';
import { getCenter } from 'ol/extent';
import { geometryObjectFromGeometry } from './geojson';
import unkinkPolygon from '@turf/unkink-polygon'
import { Polygon } from '@turf/helpers';

export interface GeometryArea<T> {
  value: number;
  unit: T;
}
/**
 * calculate area of geometry in m²
 * @param {Geometry} geometry geometry in openlayers Geometry format
 * @returns {GeometryArea<'m²'>}
 */
export function getAreaInSquaredMeters(geometry: Geometry): GeometryArea<'m²'> {
  const area = getArea(geometry, {
    projection: 'EPSG:4326',
    radius: 6378137,
  });

  return {
    value: area,
    unit: 'm²',
  };
}

/**
 * calculate area of geometry in ha
 * @param {Geometry} geometry geometry in openlayers Geometry format
 * @returns {GeometryArea<'ha'>}
 */
export function getAreaInHectares(geometry: Geometry): GeometryArea<'ha'> {
  const areaInSquareMeters = getAreaInSquaredMeters(geometry).value;
  const areaInHectares = areaInSquareMeters * 0.0001;

  return {
    value: areaInHectares,
    unit: 'ha',
  };
}


/**
 *  
 * @export
 * Return the centroid of the extent of a geometry
 * @param {Geometry} geometry geometry
 * @returns {Coordinate} coordinate of centroid
 */
export function getCentroid(geometry: Geometry) {
  const extent = geometry.getExtent();
  return getCenter(extent);
}

/**
 * verify if the geometry is a Polygon
 * @param {Geometry} geometry geometry in openlayers Geometry format
 * @returns {boolean}
 */
export function isPolygon(geometry: Geometry): boolean {
  return geometry.getType() === GeometryType.POLYGON;
}

export function intersectsItself (geometry: Geometry): boolean {
  const geojson = geometryObjectFromGeometry(geometry) as Polygon;
  try {
    const clear = unkinkPolygon(geojson);
    return clear.features.length > 1;
  } catch {
    return false;
  }
}
